export default {
  label: {
    SENT: 'Enviadas',
    RECEIVED: 'Recebidas',
    ACCEPTED: 'Aceites',
    REJECTED: 'Recusadas',
    1: 'Sem emitir',
    2: 'A aguardar emissão',
    3: 'A aguardar leitura',
    4: 'Erro na emissão',
    5: 'Lida',
    6: 'Aceite',
    7: 'Recusada',
    8: 'Cobrança externa',
    9: 'Cobrança emitida',
    10: 'Pagamento externo',
    11: 'Pagamento emitido',
    12: 'Cobrada',
    13: 'Paga',
    14: 'Retificada',
    15: 'Notificada',
    16: 'Descargada automaticamente',
    17: 'Enviada à plataforma externa',
    18: 'Aceite por plataforma externa',
    19: 'Recusada por plataforma externa',
    20: 'Pro forma enviada',
    21: 'Pro forma lida',
    22: 'Pro forma aceite',
    23: 'Pro forma enviada',
    29: 'Pro forma recusada',
    30: 'Em custódia',
    31: 'Registada',
    32: 'Em tramitação de autorização',
    33: 'Em tramitação de pagamento',
    34: 'Gestão de incidências',
    35: 'Registada no RCF',
    36: 'Contabilizada',
    37: 'Pagamento devolvido',
    38: 'Anulada',
    39: 'Solicitada anulação',
    40: 'Aceite anulação',
    41: 'Recusada anulação'
  }
}